import React from 'react';
import {
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Box,
} from '@mui/material';
import { Icon } from '@iconify/react';

const ActivityViewToggle = ({ view, onChange }) => (
  <Box display="flex" alignItems="center" gap={1} mt={3} mb={1}>
    <Typography variant="subtitle2" color="text.secondary">
      View:
    </Typography>
    <ToggleButtonGroup
      value={view}
      exclusive
      onChange={(e, val) => {
        if (val !== null) onChange(val);
      }}
      size="small"
      sx={{
        '& .MuiToggleButton-root': {
          textTransform: 'capitalize',
          px: 1.5,
          py: 0.5,
          fontSize: '0.8rem',
        },
      }}
    >
      <ToggleButton value="timeline">
        <Icon icon="mdi:timeline-clock-outline" style={{ fontSize: 18, marginRight: 4 }} />
        Timeline
      </ToggleButton>
      <ToggleButton value="sections">
        <Icon icon="mdi:view-list-outline" style={{ fontSize: 18, marginRight: 4 }} />
        Sections
      </ToggleButton>
    </ToggleButtonGroup>
  </Box>
);

export default ActivityViewToggle;
